import React from 'react';
import Navbar from '../Components/Navbar';
import PageHeader from '../Components/PageHeader';
import Footer from '../Components/Footer';
import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      title: "ERP Solutions",
      description: "End-to-end ERP solutions designed to unify your business operations, enhance productivity, and provide real-time insights. We deliver scalable systems tailored to your organization’s needs.",
      features: ["ERP Implementation & Deployment", "Custom Modules", "Finance & HR Management", "CRM Integration", "Inventory & Supply Chain"]
    },
    {
      title: "Cloud Services",
      description: "Cloud migration, management, and optimization services to enhance your business scalability. We help you leverage the power of cloud computing for improved efficiency and cost savings.",
      features: ["Cloud Migration", "Cloud Management", "AWS/Azure/GCP Services", "Cloud Security", "Disaster Recovery"]
    },
    {
      title: "Web Development",
      description: "Custom web applications using modern technologies like PHP, .NET, Java, and responsive frameworks. We create stunning, functional websites that drive results.",
      features: ["Custom Web Applications", "E-Commerce Solutions", "CMS Development", "API Integration", "Responsive Design"]
    },
    {
      title: "SEO & Digital Marketing",
      description: "Comprehensive digital marketing strategies to increase your online visibility and drive growth. We help you reach your target audience and convert visitors into customers.",
      features: ["Search Engine Optimization", "Social Media Marketing", "Content Marketing", "PPC Management", "Analytics & Reporting"]
    },
    {
      title: "Mobile Apps & Software",
      description: "Native and cross-platform mobile applications tailored to your specific business needs. We develop intuitive, high-performance apps that deliver exceptional user experiences.",
      features: ["iOS App Development", "Android App Development", "Cross-Platform Apps", "UI/UX Design", "App Maintenance"]
    },
    {
      title: "Hosting & Domains",
      description: "Reliable domain registration, hosting services, and business email solutions. We ensure your online presence is secure, fast, and always available.",
      features: ["Domain Registration", "Web Hosting", "Business Email", "SSL Certificates", "24/7 Technical Support"]
    }
  ];

  return (
    <div>
      <Navbar />
      <PageHeader 
        title="Our Services" 
        subtitle="Comprehensive IT solutions designed to empower your business and drive digital transformation." 
      />
      
      <section className="py-16 px-6 bg-netbernet-white">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                <h3 className="text-xl font-semibold mb-4 text-netbernet-black">{service.title}</h3>
                <p className="text-gray-600 mb-6">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-netbernet-blue mr-2">•</span>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 px-6 bg-gray-100">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-netbernet-black mb-4">Our Process</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We follow a structured approach to ensure your project's success from conception to delivery.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { step: "01", title: "Consultation", desc: "We discuss your requirements and goals" },
              { step: "02", title: "Planning", desc: "We create a detailed project plan" },
              { step: "03", title: "Execution", desc: "We develop and implement the solution" },
              { step: "04", title: "Support", desc: "We provide ongoing maintenance and support" }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-netbernet-blue rounded-full flex items-center justify-center text-netbernet-white font-bold text-xl mb-4 mx-auto">
                  {item.step}
                </div>
                <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-6 bg-netbernet-blue text-netbernet-white text-center">
        <div className="container mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Get Started?</h2>
          <p className="text-xl mb-10 max-w-3xl mx-auto">
            Contact us today to discuss your project requirements and get a free consultation.
          </p>
          <Link to="/contact" className="bg-netbernet-white text-netbernet-blue px-8 py-4 rounded-lg font-semibold hover:bg-blue-100 transition-colors inline-block">
            Contact Us Now
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Services;